import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import lazyWithRetry from "../utils/lazyWithRetry";
import ErrorBoundary from "../components/ErrorBoundary";
const Home = lazyWithRetry(() => import("../Home/Home"));
const Menu = lazyWithRetry(() => import("../Menu/Menu"));
const MenuDetails = lazyWithRetry(() => import("../pages/MenuDetails"));
const Blog = lazyWithRetry(() => import("../Blog/Blog"));
const BlogPost = lazyWithRetry(() => import("../pages/BlogPost"));
const About = lazyWithRetry(() => import("../About/About"));
const Subscription = lazyWithRetry(() => import("../Subscription/Subscription"));
const Contact = lazyWithRetry(() => import("../Contact/Contact"));
const Careers = lazyWithRetry(() => import("../Careers/Careers"));
const Subcriptiondestails = lazyWithRetry(() => import("../pages/Subcriptiondestails"));
const Termservice = lazyWithRetry(() => import("../pages/Termservice"));
const Termsconditions = lazyWithRetry(() => import("../pages/Termsconditions"));
const Privacypolicy = lazyWithRetry(() => import("../pages/Privacypolicy"));

export default function AppRoutes() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<div className="p-8 text-center">Loading...</div>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/menu/:category" element={<Menu />} />
          <Route path="/menu/:category/:id" element={<MenuDetails />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/post/:slug" element={<BlogPost />} />
          <Route path="/about" element={<About />} />
          <Route path="/subscription" element={<Subscription />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/subcriptiondestails" element={<Subcriptiondestails />} />
          <Route path="/termservice" element={<Termservice />} />
          <Route path="/termsconditions" element={<Termsconditions />} />
          <Route path="/privacypolicy" element={<Privacypolicy />} />
        </Routes>
      </Suspense>
    </ErrorBoundary>
  );
}
